import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form } from '../src';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "form"
    }}>{`Form`}</h1>
    <p>{`This component is a wrapper for all the other components in this library. This component handles the global state for the form itself.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <p>{`Render a `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Form } from 'react-form-package';

const myForm = (props) => (
  <Form>
    {/*
      here comes your form
      mix HTML with other
      components from this
      library: e.g.
      <Button />
      <Field />
      <RadioGroup />
      <Select />
    */}
  </Form>
);
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <p>{`You are able to pass components styled with `}<inlineCode parentName="p">{`css-in-js`}</inlineCode>{` libraries, `}<inlineCode parentName="p">{`className`}</inlineCode>{` props, or `}<inlineCode parentName="p">{`style`}</inlineCode>{` props to have a styled form. If you want to validate your form and show error messages add the `}<inlineCode parentName="p">{`validate`}</inlineCode>{` prop.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component actually renders every child within itself. This means you can create nested structures and style the form the way you need it.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property `}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`validate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<input className="rfp-input" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkbox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<input className="rfp-checkbox" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`radio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<input className="rfp-radio-group" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`radioContainer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<div className="rfp-radio-group-container" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Element that wraps the radio elements.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<button className="rfp-button" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<select className="rfp-select" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`textarea`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<textarea className="rfp-textarea" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`<div className="rfp-error-label" />`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      